import type {ProjectContact} from './schemas'

/** Select options for sales reps and the selected user, with the email added to duplicate names. */
export function repOptions(
    contacts: ProjectContact[],
    {currentUserId, value}: {currentUserId: string | null; value: string | null},
): {value: string; label: string}[] {
    const shown = contacts.filter((contact) => contact.isSalesRep || contact.id === value)
    const sameName = (name: string) =>
        shown.filter((contact) => contact.name.trim().toLowerCase() === name.trim().toLowerCase())
            .length > 1
    return shown.map((contact) => ({
        value: contact.id,
        label:
            contact.id === currentUserId
                ? `${contact.name} (you)`
                : sameName(contact.name) && contact.email
                  ? `${contact.name} (${contact.email})`
                  : contact.name,
    }))
}
